import React from "react";
import { Box, Text } from "@saleor/macaw-ui-next";

const VendorCreateView: React.FC = () => {
  return (
    <Box padding={6}>
      <Text>Vendor Create Page</Text>
      <Text>This page is under development.</Text>
    </Box>
  );
};

export default VendorCreateView;